import axiosInstance from "../../api/axiosConfig";
import logger from "../../utils/logger";

const API_URL = "/loyalty";
const API_URL_PUBLIC = "/loyaltyP";

function getAuthHeaders() {
  const token = localStorage.getItem("turnlinkToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const unwrap = async (promise, what) => {
  try {
    const res = await promise;
    return res.data;
  } catch (error) {
    logger.error(`Loyalty: error ${what}`, error);
    throw error;
  }
};

/** Programa de lealtad (add-on loyaltyCards): pestaña del panel y tarjeta pública. */
const LoyaltyService = {
  getSummary: (clientId) => unwrap(axiosInstance.get(`${API_URL}/${clientId}/summary`, { headers: getAuthHeaders() }), "cargando resumen"),

  getPendingVisits: (clientId) => unwrap(axiosInstance.get(`${API_URL}/${clientId}/pending-visits`, { headers: getAuthHeaders(), timeout: 30000 }), "cargando citas por registrar"),

  getCards: (clientId, q = "") => unwrap(axiosInstance.get(`${API_URL}/${clientId}/cards`, { params: { q }, headers: getAuthHeaders() }), "cargando tarjetas"),

  createCard: (clientId, { phone, country, name, send }) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards`, { phone, country, name, send }, { headers: getAuthHeaders() }), "creando tarjeta"),

  /** Visita por teléfono (lista "por registrar"); crea la tarjeta si no existe. */
  registerVisitByPhone: (clientId, { phone, name, eventId, note }) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/visits`, { phone, name, eventId, note }, { headers: getAuthHeaders() }), "registrando visita"),

  registerVisit: (clientId, cardId, { eventId, note } = {}) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards/${cardId}/visit`, { eventId, note }, { headers: getAuthHeaders() }), "registrando visita"),

  redeemReward: (clientId, cardId, rewardId) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards/${cardId}/redeem`, { rewardId }, { headers: getAuthHeaders() }), "canjeando recompensa"),

  adjustVisits: (clientId, cardId, visits, note) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards/${cardId}/adjust`, { visits, note }, { headers: getAuthHeaders() }), "ajustando visitas"),

  sendCard: (clientId, cardId) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards/${cardId}/send`, {}, { headers: getAuthHeaders() }), "reenviando tarjeta"),

  rotateToken: (clientId, cardId) =>
    unwrap(axiosInstance.post(`${API_URL}/${clientId}/cards/${cardId}/rotate-token`, {}, { headers: getAuthHeaders() }), "generando link"),

  updateSettings: (clientId, settings) =>
    unwrap(axiosInstance.put(`/clients/${clientId}/loyalty-settings`, settings, { headers: getAuthHeaders() }), "guardando programa"),

  // ---- Tarjeta pública (sin sesión; el token del link es la llave) ----
  getPublicCard: (token) => unwrap(axiosInstance.get(`${API_URL_PUBLIC}/card/${encodeURIComponent(token)}`), "cargando tarjeta"),
  publicWalletUrl: (token) => `${process.env.REACT_APP_API || "/api"}${API_URL_PUBLIC}/card/${encodeURIComponent(token)}/wallet`,
};

export default LoyaltyService;
